<template lang="pug">
section.menu-lateral
    span.sair-btn
        hr
        i.collapse-arrow.el.el-icon-arrow-right(
            v-if='isCollapse',
            @click='changeCollapse'
        )
        i.collapse-arrow.el.el-icon-arrow-left(v-else, @click='changeCollapse')
            span.text {{ $t('mensagens.comuns.esconderMenu') }}

    .menu-lateral-container
        el-menu.el-menu(
            :default-active='buscarIndexRota',
            @open='',
            @close='',
            :collapse='isCollapse'
        )
            div(v-for='(button, index) in buttons')
                el-menu-item(
                    :index='criarIndex(index)',
                    @click='goTo(button[0].route)',
                    :key='button[0].name',
                    :class='button[0].isNew ? "label-novo" : ""',
                    v-if='button[0].submenus.length === 0'
                )
                    i(:class='button[0].iconClass')
                    .title(slot='title')
                        span
                            | {{ $t(button[0].nameTranslationKey) }}
                    span.label-novo(v-if='button[0].isNew && isCollapse') Novo
                    span.label-novo(
                        v-if='button[0].isNew && !isCollapse',
                        style='width: 20%'
                    ) {{ $t('mensagens.comuns.novo') }}

                el-submenu(
                    :index='criarIndex(index)',
                    :key='button[0].name',
                    v-if='button[0].submenus.length > 0'
                )
                    template(slot='title')
                        i(:class='button[0].iconClass')
                        span.title(slot='title') {{ $t(button[0].nameTranslationKey) }}

                    el-menu-item(
                        v-for='(button1, index1) in button[0].submenus',
                        :index='criarSubIndex(index, index1)',
                        @click='goTo(button1.componentOptions.actions[0][0].route)',
                        :key='button1.componentOptions.actions[0][0].name',
                        :class='button1.componentOptions.actions[0][0].name'
                    )
                        i(
                            :class='button1.componentOptions.actions[0][0].iconClass'
                        )
                        .title(slot='title')
                            span {{ $t(button1.componentOptions.actions[0][0].nameTranslationKey) }}
</template>

<script>
import FloatBox from '@/components/layout/FloatBox';

export default {
    name: 'MenuLateral',

    extends: FloatBox,

    data() {
        return {
            isCollapse: true
        };
    },
    computed: {
        buscarIndexRota: function () {
            this.buttons.forEach(botao => {
                if (botao[0].submenus === undefined) {
                    botao[0].submenus = [];
                }
            });

            let rota = this.$route.name;

            let index = this.buttons.findIndex(item => {
                return item[0].route === rota;
            });

            let indexSubmenu = -1;
            let indexMenuPrincipalSubmenu = '10-';

            this.buttons.forEach((item, idx) => {
                if (item[0].submenus.length > 0) {
                    indexMenuPrincipalSubmenu = idx.toString() + '-';
                    indexSubmenu = item[0].submenus.findIndex(submenu => {
                        return (
                            submenu.componentOptions.actions[0][0].route ===
                            rota
                        );
                    });
                }
            });

            if (indexSubmenu >= 0) {
                return indexMenuPrincipalSubmenu + indexSubmenu.toString();
            }

            if (index || index === 0) {
                return index.toString();
            }

            return '';
        }
    },

    methods: {
        criarIndex(index) {
            return index.toString();
        },

        criarSubIndex(index, index1) {
            return index.toString() + '-' + index1.toString();
        },

        changeCollapse() {
            if (this.isCollapse) {
                this.isCollapse = false;
            } else {
                this.isCollapse = true;
            }
        },

        goTo(route) {
            if (this.$route.name !== route) {
                if (this.$router.history.current.name !== route) {
                    this.$router.push({ name: route });
                }
            }
            this.isCollapse = true;
        }
    }
};
</script>

<style lang="scss">
.menu-lateral {
    position: fixed;
    z-index: 200;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    background-color: var(--primary);
    height: 100vh;
    color: var(--white);
    padding-top: 70px;
    box-shadow: 4px 0 5px 0 rgba(0, 65, 60, 0.2);

    .menu-lateral-container {
        overflow-x: hidden;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-thumb {
            border: 2px solid var(--white);
        }
    }

    &::before {
        content: '';
        position: absolute;
        width: 32px;
        height: 15px;
        top: 65px;
        right: -32px;
        border-top-left-radius: 32px;
        border-bottom-right-radius: 40px;
        -webkit-box-shadow: -20px -20px 0 var(--primary);
        box-shadow: -14px -3px 0 var(--primary);
        z-index: -1;
    }

    .el-menu:not(.el-menu--collapse) {
        width: 200px;

        &::before {
            content: '';
            position: absolute;
            width: 32px;
            height: 15px;
            top: -5px;
            right: -32px;
            border-radius: 32px 10px 40px 10px;
            -webkit-box-shadow: -20px -20px 0 var(--primary);
            box-shadow: -14px -3px 0 var(--primary);
            z-index: -1;
        }
    }

    .el-menu {
        width: 70px;
        background-color: var(--primary) !important;
        border: 0;
    }

    .el-menu-item {
        color: var(--white);
        border: 0;
        margin: 2px 5px;
        transition: all 0.1s ease-in-out;
        border-radius: 5px;
        display: flex;
        vertical-align: middle;

        .title {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            line-height: 19px;
            white-space: break-spaces;

            span:is(:first-child) {
                width: 120px;
                margin: 0px 5px 0px 0px;
            }

            span:not(:first-child) {
                margin: -10px 5px 0px 0px;
            }
        }

        i {
            color: var(--white);
            font-size: 40px;
            margin-right: 10px;
            margin-left: -3px;

            &:hover {
                color: var(--primary);
            }

            &::before {
                margin-top: 0;
                margin-bottom: 5px;
            }
        }

        &:hover,
        &:focus {
            background-color: var(--menu-item-hover);
            color: var(--color-button-hover);

            i {
                color: var(--color-button-hover);
            }
        }

        &:hover i:before {
            background-color: var(--white) !important;
        }

        &.is-active {
            background-color: var(--menu-item-hover);
            color: var(--primary);

            i {
                color: var(--primary);
            }

            .lyra-icon::before {
                content: '';
                background-color: var(--primary);
            }
        }

        .label-novo {
            position: absolute;
            top: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 55%;
            height: 25%;
            background-color: var(--danger);
            color: var(--white);
            font-size: 9px;
            font-weight: 600;
            border-radius: 12px;
        }
    }

    .el-submenu {
        color: var(--white);
        list-style: none;
        margin: 0;
        padding-left: 0;
        transition: all 0.1s ease-in-out;

        .el-menu-item {
            min-width: 180px;
            &:hover,
            &:focus {
                background-color: var(--menu-item-hover) !important;
                color: var(--color-button-hover);

                i {
                    color: var(--color-button-hover);
                }
            }
        }

        &.is-active .el-submenu__title {
            border-bottom-color: #00413c;
            background-color: var(--menu-item-hover) !important;
            color: var(--primary);
        }
    }

    .el-submenu__title {
        border: 0;
        transition: all 0.3s ease-in-out;
        border-radius: 5px;
        height: 56px;
        line-height: 50px;
        font-size: 40px;
        color: #303133;
        margin: 0px 5px;
        list-style: none;
        cursor: pointer;
        position: relative;
        box-sizing: border-box;
        white-space: nowrap;
        background-color: var(--primary);

        i {
            vertical-align: middle;
            margin-right: 8px;
            margin-left: -3px;
            text-align: end;
            font-size: 30px;
            color: var(--white);
        }

        i.el-submenu__icon-arrow.el-icon-arrow-down {
            font-size: 14px;
            margin: -6px 0 0 0;
        }

        .title {
            color: var(--white);
            font-size: 14px;
            width: 100% !important;

            span:not(:first-child) {
                margin: 2px;
                margin-top: -8px;
            }

            &:hover {
                color: var(--primary);
            }
        }

        &.is-opened {
            background-color: var(--menu-item-hover);
            color: var(--primary);

            i {
                color: var(--primary);
                content: '';
                background-color: var(--primary);
            }
        }

        &:hover,
        &:focus {
            background-color: var(--menu-item-hover);
            color: var(--color-button-hover);

            .title {
                color: var(--color-button-hover);
            }

            i {
                color: var(--color-button-hover);
            }
        }
    }

    span.text {
        font-size: 15px;
        float: right;
        margin-top: 7px;
    }

    hr {
        border-top: 2px solid hsl(0deg 0% 100% / 10%) !important;
        margin: 1rem !important;
    }

    .sair-btn {
        text-align: center;
    }
}

.collapse-arrow {
    color: var(--white);
    text-align: right;
    font-size: 28px;
    margin: 0px 4px 8px 0px;
    cursor: pointer;
}

div.el-submenu__title > i.el-submenu__icon-arrow.el-icon-arrow-right {
    display: none;
}

.el-menu--collapse .el-submenu__title > span {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
}

.el-menu--vertical > ul {
    background-color: var(--primary) !important;
    border-radius: 5px;

    .el-menu-item {
        color: var(--white);
        border: 0px;
        margin: 2px 5px;
        // height: 47px !important;
        transition: all 0.1s ease-in-out;
        border-radius: 5px;
        display: flex;
        vertical-align: middle;

        .title {
            display: block;
            flex-wrap: wrap;
            align-items: center;
            line-height: 50px;

            span:not(:first-child) {
                margin-top: -8px;
            }
        }

        i {
            color: var(--white);
            font-size: 40px;
            margin-right: 10px;
            margin-left: -3px;

            &:hover {
                color: var(--primary);
            }

            &::before {
                margin-top: 0px;
                margin-bottom: 5px;
            }
        }

        &:hover,
        &:focus {
            background-color: var(--menu-item-hover) !important;
            color: var(--color-button-hover);

            i {
                color: var(--color-button-hover);
            }
        }

        &:hover i:before {
            background-color: var(--white) !important;
        }

        &.is-active {
            background-color: var(--menu-item-hover) !important;
            color: var(--primary);

            i {
                color: var(--primary);
            }

            .lyra-icon::before {
                content: '';
                background-color: var(--primary);
            }
        }
    }
}
</style>
